import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseTrackPlaylistAppearancesProps {
  trackId: string;
  date?: Date;
}

export const useTrackPlaylistAppearances = ({ trackId, date }: UseTrackPlaylistAppearancesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const playlistAppearancesQuery = useTRPCQuery(
    trpcMusicAPI.tracks.playlistAppearances.queryOptions({
      trackId,
      date,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return playlistAppearancesQuery;
};
